import { CSSProperties, ReactNode } from 'react';

import cx from 'classnames';
import type { GroupBase, OptionProps } from 'react-select-5';
import { components } from 'react-select-5';

import s from './index.module.css';

type Props<
  Option = unknown,
  IsMulti extends boolean = boolean,
  Group extends GroupBase<Option> = GroupBase<Option>,
> = OptionProps<Option, IsMulti, Group> & {
  action?: ReactNode;
  style?: CSSProperties;
};

export function OptionWithAction<
  Option = unknown,
  IsMulti extends boolean = boolean,
  Group extends GroupBase<Option> = GroupBase<Option>,
>(props: Props<Option, IsMulti, Group>) {
  const { children, innerProps, innerRef, data, action, style, getClassNames, getStyles, selectProps } = props;

  const getOptionLabel = selectProps.getOptionLabel || ((option) => (option as unknown as { label: string }).label);

  const renderAction = () => {
    if (!action) return null;
    if (props?.data && typeof props.data === 'object' && '__isNew__' in props.data && props.data.__isNew__) return null;

    return action;
  };

  return (
    <components.Option<Option, IsMulti, Group>
      {...props}
      innerProps={{
        ...innerProps,
        title: getOptionLabel(data),
        style: { ...(getStyles('option', props) as CSSProperties), ...style },
      }}
      innerRef={innerRef}
      className={cx(s.option, getClassNames('option', props))}
    >
      <div className={s.label}>
        <span className={s.labelTitle}>{children}</span>
      </div>

      {renderAction()}
    </components.Option>
  );
}
